<script setup>
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import { RouterView } from "vue-router";
import { useContextStore } from "@/stores/context";
import { onMounted, ref, watch } from "vue";
import DomHandler from "@/composables/handlers/DomHandler";
import { sleep } from "@/composables/sleep";
import LoaderComponent from "@/components/Utils/LoaderComponent.vue";

const context = useContextStore();
const loadingApplication = ref(null);

onMounted(() => {
  handleApplicationLoader();

  DomHandler.setHtmlStyle();
});

watch(
  () => context.isDarkMode,
  () => {
    DomHandler.setHtmlStyle();
  }
);

watch(
  () => context.isLoadingApplication,
  () => {
    handleApplicationLoader();
  }
);

async function handleApplicationLoader() {
  if (loadingApplication.value === null) {
    loadingApplication.value = true;
  }

  await sleep(200);

  loadingApplication.value = context.isLoadingApplication;
}

</script>

<template>

  <section :class="loadingApplication ? 'hidden' : ''">
    <HeaderComponent />

    <section>
      <RouterView />
    </section>

    <FooterComponent />
  </section>

  <section 
    :class="loadingApplication ? '' : 'hidden'"
    class="absolute top-0 left-0 right-0 bottom-0 bg-white h-screen flex items-center"
  >
    <LoaderComponent />
  </section>

</template>

<style>
  :root {
    --scrollbar-track-color: #1e2a3a;
    --scrollbar-thumb-color: #3a4b61;
  }

  html::-webkit-scrollbar {
    width: 8px;
  }
  html::-webkit-scrollbar-track {
    background: var(--scrollbar-track-color);
  }
  html::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb-color);
    border-radius: 4px;
    border: 2px solid transparent;
  }
  html {
    scrollbar-width: 8px;
    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-track-color);
  }
</style>